(function () {
  'use strict';

  var PARAM = 'ups_model';
  var SKU_PARAM = 'sku';
  var MAX_LENGTH = 80;
  var NOTE_PREFIX_EN = 'Shopping for UPS model: ';
  var NOTE_PREFIX_FR = 'Modèle d’onduleur recherché : ';
  var REFERENCE_PREFIX_EN = 'Product reference: ';
  var REFERENCE_PREFIX_FR = 'Référence du produit : ';
  var FORM_SCAN_LIMIT = 40;
  var FORM_SCAN_DELAY = 250;
  var params;

  try {
    params = new URLSearchParams(window.location.search);
  } catch (error) {
    return;
  }

  function cleanModel(value) {
    return (value || '')
      .replace(/[^A-Za-z0-9 ._+\/#()-]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, MAX_LENGTH);
  }

  var model = cleanModel(params.get(PARAM));
  var productReference = cleanModel(params.get(SKU_PARAM));
  if (!model && !productReference) return;

  var isFrench = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var formContext = model || (isFrench ? REFERENCE_PREFIX_FR : REFERENCE_PREFIX_EN) + productReference;
  var observedFormRoots = new WeakSet();
  var boundInputs = new WeakSet();
  var logicalFieldStates = new WeakMap();
  var settingInputs = new WeakSet();

  function isCartPath(pathname) {
    return pathname === rootUrl.replace(/\/$/, '') + '/cart';
  }

  function isContextPath(pathname) {
    return (
      pathname.indexOf('/products/') > -1 ||
      pathname.indexOf('/collections/') > -1 ||
      isCartPath(pathname) ||
      pathname.indexOf('/pages/contact') > -1 ||
      pathname.indexOf('/pages/nous-joindre') > -1 ||
      pathname.indexOf('/pages/request-a-quote') > -1
    );
  }

  function withModel(rawUrl) {
    if (!model) return rawUrl;
    try {
      var url = new URL(rawUrl, window.location.origin);
      if (url.origin !== window.location.origin || !isContextPath(url.pathname)) return rawUrl;
      url.searchParams.set(PARAM, model);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return rawUrl;
    }
  }

  function addHiddenField(form, name, value) {
    if (!form || form.querySelector('input[name="' + name + '"]')) return;
    var field = document.createElement('input');
    field.type = 'hidden';
    field.name = name;
    field.value = value;
    field.setAttribute('data-upsb-model-context-field', '');
    form.appendChild(field);
  }

  function enhanceForms() {
    if (model) {
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        if (!form.closest || !form.closest('product-form')) {
          addHiddenField(form, 'return_to', withModel(rootUrl.replace(/\/$/, '') + '/cart'));
        }
      });
      document
        .querySelectorAll('facet-filters-form form, form.upsb-col-filter-form, form.upsb-col-sort-form')
        .forEach(function (form) {
          addHiddenField(form, PARAM, model);
        });
    }
    enhanceContextFields(document);
    observeEmbeddedForms();
  }

  function getLogicalFieldState(root, input) {
    var scope = root;
    if (root === document) scope = (input.closest && input.closest('form')) || input;
    var state = logicalFieldStates.get(scope);
    if (!state) {
      state = { buyerControlled: false, value: '' };
      logicalFieldStates.set(scope, state);
    }
    return state;
  }

  function bindBuyerEditGuard(input, state) {
    if (boundInputs.has(input)) return;
    boundInputs.add(input);
    function markBuyerEdit() {
      if (settingInputs.has(input)) return;
      state.buyerControlled = true;
      state.value = String(input.value || '');
    }
    input.addEventListener('input', markBuyerEdit);
    input.addEventListener('change', markBuyerEdit);
  }

  function setNativeInputValue(input, value, isPrefill) {
    var prototype = window.HTMLInputElement && window.HTMLInputElement.prototype;
    var descriptor = prototype && Object.getOwnPropertyDescriptor(prototype, 'value');
    settingInputs.add(input);
    try {
      if (descriptor && descriptor.set) descriptor.set.call(input, value);
      else input.value = value;
      if (isPrefill) input.setAttribute('data-upsb-model-context-prefilled', '');
      else if (input.removeAttribute) input.removeAttribute('data-upsb-model-context-prefilled');
      input.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
      input.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    } finally {
      settingInputs.delete(input);
    }
  }

  function enhanceContextFields(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(
      'input[name="contact[UPS model]"], input[name="contact[UPS Model]"], input[data-ups-model], ' +
        'input[id="custom#ups_model"], input[name="custom#ups_model"], input[data-testid="field-custom#ups_model"]'
    ).forEach(function (input) {
      var state = getLogicalFieldState(root, input);
      bindBuyerEditGuard(input, state);
      var currentValue = String(input.value || '');
      if (state.buyerControlled) {
        if (currentValue !== state.value) setNativeInputValue(input, state.value, false);
        return;
      }
      if (currentValue.trim()) return;
      setNativeInputValue(input, formContext, true);
    });
  }

  function observeEmbeddedForms() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      var shadowRoot = host.shadowRoot;
      if (!shadowRoot) return;
      enhanceContextFields(shadowRoot);
      if (observedFormRoots.has(shadowRoot)) return;
      observedFormRoots.add(shadowRoot);
      new MutationObserver(function () {
        enhanceContextFields(shadowRoot);
      }).observe(shadowRoot, { childList: true, subtree: true });
    });
  }

  function scanEmbeddedForms(attempt) {
    observeEmbeddedForms();
    if (attempt + 1 >= FORM_SCAN_LIMIT) return;
    window.setTimeout(function () {
      scanEmbeddedForms(attempt + 1);
    }, FORM_SCAN_DELAY);
  }

  function renderBanner() {
    if (!isContextPath(window.location.pathname) || document.querySelector('[data-upsb-model-context]')) return;
    // 8 Oct 2026 battery declutter: a battery page with a fit line ("Listed for <model>: 3 x 12 V 9 Ah") carries the model
    // there instead of a full-width bar; ?ups_model replaces the shown model only when it is in this battery's list.
    var fit = document.querySelector('[data-upsb-fit-line]');
    if (fit && model) {
      var norm = function (v) { return String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); };
      var want = norm(model);
      var listed = (fit.getAttribute('data-models') || '').split('|').filter(function (m) { return norm(m) === want; })[0];
      var slot = fit.querySelector('[data-upsb-fit-model]');
      if (listed && slot) {
        var brand = fit.getAttribute('data-brand') || '';
        slot.textContent = (brand && listed.toUpperCase().indexOf(brand.toUpperCase()) === -1 ? brand + ' ' : '') + listed.trim();
      }
      if (listed) return;
    }
    var main = document.getElementById('MainContent');
    if (!main) return;
    var banner = document.createElement('aside');
    banner.className = 'upsb-model-context page-width';
    banner.setAttribute('data-upsb-model-context', '');
    banner.setAttribute(
      'aria-label',
      model
        ? isFrench
          ? 'Contexte du modèle recherché'
          : 'Shopping model context'
        : isFrench
          ? 'Contexte de la référence du produit'
          : 'Product reference context'
    );
    var label = document.createElement('span');
    label.className = 'upsb-model-context__label';
    label.textContent = model
      ? isFrench
        ? 'Vous magasinez pour'
        : 'Shopping for'
      : isFrench
        ? 'Référence du produit'
        : 'Product reference';
    var value = document.createElement('strong');
    value.className = 'upsb-model-context__value';
    value.textContent = model || productReference;
    banner.appendChild(label);
    banner.appendChild(value);
    if (!document.querySelector('[data-upsb-model-context-style]')) {
      var style = document.createElement('style');
      style.setAttribute('data-upsb-model-context-style', '');
      style.textContent =
        '.upsb-model-context{display:flex;flex-wrap:wrap;align-items:baseline;gap:.4rem .8rem;margin-block:1.2rem 0;padding-block:1rem;color:rgb(var(--color-foreground));background:rgba(var(--color-foreground),.05);border-left:.3rem solid #c8102e}' +
        '.upsb-model-context__label{font-size:1.3rem}.upsb-model-context__value{overflow-wrap:anywhere;font-size:1.4rem}';
      (document.head || document.documentElement).appendChild(style);
    }
    main.insertBefore(banner, main.firstChild);
  }

  function mergeCartNote(note) {
    if (!model) return String(note || '');
    var lines = String(note || '').split(/\r?\n/).filter(function (line) {
      return line.indexOf(NOTE_PREFIX_EN) !== 0 && line.indexOf(NOTE_PREFIX_FR) !== 0;
    });
    var customerNote = lines.join('\n').replace(/\n+$/, '');
    var contextLine = (isFrench ? NOTE_PREFIX_FR : NOTE_PREFIX_EN) + model;
    return customerNote ? customerNote + '\n' + contextLine : contextLine;
  }

  var noteUpdatePending = null;
  function updateCartNote() {
    if (!model) return Promise.resolve(null);
    if (noteUpdatePending) return noteUpdatePending;
    noteUpdatePending = fetch(rootUrl + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('cart read failed');
        return response.json();
      })
      .then(function (cart) {
        var nextNote = mergeCartNote(cart.note);
        if (nextNote === (cart.note || '') || nextNote.length > 500) return null;
        return fetch(rootUrl + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: nextNote }),
        });
      })
      .catch(function () {
        return null;
      })
      .then(function (result) {
        noteUpdatePending = null;
        return result;
      });
    return noteUpdatePending;
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || link.hasAttribute('download')) return;
      var updated = withModel(link.getAttribute('href'));
      if (updated !== link.getAttribute('href')) link.setAttribute('href', updated);
    },
    true
  );

  function init() {
    renderBanner();
    enhanceForms();
    scanEmbeddedForms(0);
    if (model && isCartPath(window.location.pathname)) updateCartNote();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        enhanceForms();
      });
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return null;
      return updateCartNote();
    });
  }

  window.UPSBModelContext = {
    cleanModel: cleanModel,
    withModel: withModel,
    mergeCartNote: mergeCartNote,
    enhanceForms: enhanceForms,
    enhanceContextFields: enhanceContextFields,
    observeEmbeddedForms: observeEmbeddedForms,
    updateCartNote: updateCartNote,
  };
})();
